class MiniCartButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", () => {
      // The one open the shopper asks for — dl_view_cart is tracked for it alone.
      document.dispatchEvent(
        new CustomEvent("mini-cart:open", { detail: { trackView: true } }),
      );
    });
  }
}

if (!customElements.get("mini-cart-button")) {
  customElements.define("mini-cart-button", MiniCartButton);
}
